/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-11 14:31:11
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  checkEnv: '正在检查环境...',
  editPassword: '修改密码',
  curPassword: '现用密码',
  newPassword: '新密码',
  confirmPassword: '确认密码',
  curPasswordNull: '请输入现用密码',
  newPasswordNull: '请输入新密码',
  newPasswordEdrror: '请输入包含大小写、数字、特殊字符(仅支持!@#$%^&*();?.,)8-32位密码',
  disaccord: '两次输入密码不一样',
  samePassword: '新密码与现用密码相同，请您修改',
  confirmPasswordNull: '请输入确认密码',
  logOut: '退出登录',
  confirmLogOut: '确认退出运维平台？',
  success: '修改成功',
  operatingEnv: '运行环境管理',
  operatingEnvName: '运行环境名称',
  operatingEnvNull: '请输入运行环境名称',
  nameError: '运行环境名称只能是中文、英文和数字',
  successTip: '修改成功',
  defaultName: '未命名运行环境',
  verison: '运维平台版本：',
  goback: '返回',
});
